(function () {
    var toast = document.querySelector('[data-context-toast]');
    if (!toast) return;

    var threshold = parseInt(toast.getAttribute('data-threshold') || '0', 10);
    var duration = parseInt(toast.getAttribute('data-duration') || '4500', 10);
    var progressTpl = toast.getAttribute('data-progress-template') || '{amount} away from free shipping';
    var unlockedTpl = toast.getAttribute('data-unlocked-template') || 'Free shipping unlocked';
    var msgEl = toast.querySelector('[data-ctoast-msg]');
    var fillEl = toast.querySelector('[data-ctoast-fill]');
    var trackEl = toast.querySelector('[data-ctoast-track]');

    var hideTimer = null;
    var lastItemCount = null;
    var firstCart = true;

    function fmtMoney(cents) {
      if (window.Sherbet && typeof window.Sherbet.formatMoney === 'function') {
        return window.Sherbet.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function render(cart) {
      var unlocked = threshold > 0 && cart.total_price >= threshold;
      var state = unlocked ? 'unlocked' : 'progress';
      toast.setAttribute('data-state', state);

      if (unlocked) {
        msgEl.innerHTML = '<strong>' + escapeHtml(unlockedTpl) + '</strong>';
        if (trackEl) trackEl.style.display = 'none';
      } else if (threshold > 0) {
        var remaining = Math.max(0, threshold - cart.total_price);
        var pct = Math.min(100, (cart.total_price * 100) / threshold);
        msgEl.innerHTML = escapeHtml(progressTpl).replace(
          '{amount}',
          '<strong>' + escapeHtml(fmtMoney(remaining)) + '</strong>'
        );
        if (trackEl) trackEl.style.display = '';
        if (fillEl) fillEl.style.width = pct + '%';
      } else {
        // No threshold configured: just show item-added confirmation.
        msgEl.innerHTML = '<strong>Added to cart</strong>';
        if (trackEl) trackEl.style.display = 'none';
      }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var canPopover = typeof toast.showPopover === 'function';

    function show(cart) {
      render(cart);
      toast.hidden = false;
      // The cart drawer is a modal <dialog> (browser top layer); a normal
      // z-indexed element can't paint above it. Showing the toast as a
      // popover puts it in the top layer too, so it sits over the cart
      // overlay. Older browsers fall back to the plain fixed/z-index toast.
      if (canPopover && !toast.matches(':popover-open')) {
        try { toast.showPopover(); } catch (e) {}
      }
      // Force reflow so the transition runs from the hidden state.
      // eslint-disable-next-line no-unused-expressions
      toast.offsetHeight;
      toast.setAttribute('data-visible', 'true');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, duration);
    }

    function hide() {
      toast.removeAttribute('data-visible');
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      setTimeout(function () {
        if (!toast.hasAttribute('data-visible')) {
          if (canPopover && toast.matches(':popover-open')) {
            try { toast.hidePopover(); } catch (e) {}
          }
          toast.hidden = true;
        }
      }, 350);
    }

    function fetchCart(forceShow) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var added = lastItemCount !== null && cart.item_count > lastItemCount;
          var changed = lastItemCount !== null && cart.item_count !== lastItemCount;
          lastItemCount = cart.item_count;
          if (firstCart) {
            firstCart = false;
            return; // Never show on initial page load.
          }
          if (forceShow || added || changed) show(cart);
        })
        .catch(function () {});
    }

    // Prime the cached count on load without showing the toast.
    fetchCart(false);

    document.addEventListener('cart:updated', function () { fetchCart(true); });
    document.addEventListener('cart:refreshed', function () { fetchCart(false); });

    // Pause auto-hide on hover, resume on leave.
    toast.addEventListener('mouseenter', function () {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    });
    toast.addEventListener('mouseleave', function () {
      hideTimer = setTimeout(hide, 1500);
    });
  })();
